module.exports = __webpack_public_path__ + "img/af5f6aa.png";